import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { StepContent } from "../../styles/StyledComponents";
import { PREMIO_ANNUALE } from "../../constants";

const Step0RiepilogoIniziale = ({ formData }) => {
  return (
    <StepContent>
      {/* Prezzo Polizza */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #ff6f00, #ff9800)",
          color: "white",
          borderRadius: 3,
          p: 4,
          mb: 3,
          position: "relative",
        }}
      >
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Polizza Vita Protetta
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9, mb: 3 }}>
          Protezione completa per te e la tua famiglia
        </Typography>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
          <Typography variant="h2" fontWeight={700}>
            € {PREMIO_ANNUALE}
          </Typography>
          <Typography variant="h6">/anno</Typography>
        </Box>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
          Pagamento unico annuale
        </Typography>
      </Box>

      {/* Assicurato */}
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <PersonRoundedIcon sx={{ color: "#673ab7", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Assicurato
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Nome Completo
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formData.nome} {formData.cognome}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Data Nascita
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {formData.dataNascita
                ? new Date(formData.dataNascita).toLocaleDateString("it-IT")
                : ""}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Coperture Assicurative */}
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <ShieldRoundedIcon sx={{ color: "#2196f3", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Coperture Assicurative
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">
              Decesso accidentale: Massimale 40.000€
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">
              Invalidità totale permanente: Massimale 40.000€ (condiviso tra infortunio e malattia)
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">
              Inabilità totale temporanea: 1000€ Protezione del Reddito
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">Protezione Bollette: Fino a 1000€</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <CheckCircleRoundedIcon sx={{ color: "#4caf50", fontSize: 20 }} />
            <Typography variant="body2">Protezione Premio: Fino a 1000€</Typography>
          </Box>
        </Box>
      </Box>

      {/* Date Importanti */}
      <Box
        sx={{
          border: (theme) =>
            `2px solid ${
              theme.palette.mode === "light" ? "#ff9800" : "#ff6f00"
            }`,
          borderRadius: 2,
          p: 3,
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#fff8e1"
              : "rgba(255, 152, 0, 0.05)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
          <CalendarMonthRoundedIcon sx={{ color: "#ff9800", fontSize: 28 }} />
          <Typography variant="h6" fontWeight={600}>
            Date Importanti
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Inizio copertura:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {new Date().toLocaleDateString("it-IT", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="text.secondary">
              Prossimo rinnovo:
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {new Date(
                new Date().setFullYear(new Date().getFullYear() + 1),
              ).toLocaleDateString("it-IT", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </StepContent>
  );
};

export default Step0RiepilogoIniziale;
